import {
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
} from "antd";
import styles from "../flexible-request-form.module.css";
import DigitsDatePicker from "@/components/inputs/DigitsDatePicker";
import {
  formatNumberWithThousands,
  MAX_INTEGER_INPUT_VALUE,
  MAX_NUMBER_INPUT_VALUE,
  MIN_INTEGER_INPUT_VALUE,
  MIN_NUMBER_INPUT_VALUE,
  normalizeDecimalInput,
} from "@/utils/fieldValueConverter";

const GroupRenderer = ({ group, deps }) => {
  return (
    <div key={group.uuid}>
      <Divider
        style={{ borderColor: "var(--color-orange)" }}
        titlePlacement="left"
      >
        {group.name}
      </Divider>

      <Row gutter={20}>
        {group.fields
          .sort((a, b) => a.idx - b.idx)
          .map((field) => (
            <Col span={24} key={field.uuid}>
              <Form.Item
                colon={false}
                labelAlign="left"
                name={field.uuid}
                label={
                  field.type !== "checkbox" ? (
                    <span className={styles.form_label}>{field.name}</span>
                  ) : (
                    ""
                  )
                }
                rules={getRules(field)}
                valuePropName={field.type === "checkbox" ? "checked" : "value"}
                labelCol={field.type === "checkbox" ? { span: 0 } : { span: 8 }}
                wrapperCol={
                  field.type === "checkbox" ? { span: 24 } : { span: 16 }
                }
              >
                <FieldRenderer
                  placeholder={field.placeholder}
                  field={field}
                  deps={deps}
                />
              </Form.Item>
            </Col>
          ))}
      </Row>
    </div>
  );
};

export default GroupRenderer;

const TextField = (props) => <Input {...props} />;

const TextAreaField = (props) => <Input.TextArea rows={3} {...props} />;

const FloatField = (props) => (
  <InputNumber style={{ width: "100%" }} {...props} />
);

const IntegerField = (props) => (
  <InputNumber
    style={{ width: "100%" }}
    precision={0}
    {...props}
  />
);

const MoneyField = (props) => (
  <Space.Compact style={{ width: "100%" }}>
    <InputNumber
      step="0.01"
      precision={2}
      style={{ width: "100%" }}
      formatter={formatNumberWithThousands}
      parser={normalizeDecimalInput}
      {...props}
    />
    <span className="input-after">руб.</span>
  </Space.Compact>
);

const DateField = (props) => (
  <DigitsDatePicker style={{ width: "100%" }} {...props} />
);

const DateTimeField = (props) => (
  <DigitsDatePicker type="moment" style={{ width: "100%" }} {...props} />
);

const SelectField = ({ field, ...props }) => (
  <Select
    {...props}
    options={field.options
      ?.sort((a, b) => a.idx - b.idx)
      .map((opt) => ({
        label: opt.value,
        value: opt.value,
      }))}
  />
);

const CheckboxField = ({ field, ...props }) => (
  <Checkbox {...props}>{field.name}</Checkbox>
);

const FIELD_MAP = {
  text: TextField,
  float: FloatField,
  integer: IntegerField,
  money: MoneyField,
  select: SelectField,
  date: DateField,
  moment: DateTimeField,
  checkbox: CheckboxField,
  textarea: TextAreaField,
};

const FieldRenderer = ({ field, deps, ...props }) => {
  const Component = FIELD_MAP[field.type] || TextField;
  return <Component field={field} deps={deps} {...props} />;
};

const getRules = (field) => {
  const rules = [];

  if (field.is_required) {
    rules.push({
      required: true,
      message: `Поле "${field.name}" обязательно`,
    });
  }

  if (["float", "integer", "money"].includes(field.type)) {
    rules.push({
      type: "number",
      min:
        field.type === "integer"
          ? MIN_INTEGER_INPUT_VALUE
          : MIN_NUMBER_INPUT_VALUE,
      max:
        field.type === "integer"
          ? MAX_INTEGER_INPUT_VALUE
          : MAX_NUMBER_INPUT_VALUE,
      message: "Число выходит за допустимый диапазон",
    });
  }

  return rules;
};
